// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3uQMm","col":"styles_col__3Wlwl"};